import { OrderItem } from '../../models';

/**
 * What the customer actually pays for this order item. `totalAmount` is gross: it excludes tax,
 * the promotion discount AND the proration credit of a monthly -> annual switch, all of which the
 * BE only applies to the order total. Leaving `creditAmount` out here made an upgrade show the
 * full annual price.
 */
export const getItemPayAmount = (item: OrderItem) => (
  item.totalAmount - item.discountAmount + item.taxAmount - (item.creditAmount ?? 0)
);
